import { render, staticRenderFns } from "./ProjectsPanelHeaderAddProject.vue?vue&type=template&id=013b6608&"
import script from "./ProjectsPanelHeaderAddProject.vue?vue&type=script&lang=js&"
export * from "./ProjectsPanelHeaderAddProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports